// extracted by mini-css-extract-plugin
module.exports = {"head":"PopupHeader_head__F0Crl"};